import { createContext, useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";

/** Undefined keeps the toolbar inline; null waits for a relocated host to mount. */
export const ListSheetToolbarTarget = createContext<HTMLElement | null | undefined>(undefined);

export function ListSheetToolbar({ children }: { children: ReactNode }) {
  const target = useContext(ListSheetToolbarTarget);
  const toolbar = <div className="list-sheet-toolbar">{children}</div>;
  return target === undefined ? toolbar : target ? createPortal(toolbar, target) : null;
}
